import Blum from "shared/assets/blum-logo.svg?react";

import { Card } from "./card/card";

type Props = {
  expirationDate: number;
};

export const BlumCert = (props: Props) => {
  return (
    <Card
      cardClassName="border-none bg-black bg-gradient-to-b from-black to-[#646464] text-white"
      iconWrapperClassName={
        "bg-black flex items-center justify-center border-black"
      }
      icon={<Blum className="size-10" />}
      view="big"
      title="Blum.io"
      {...props}
    >
      <Blum className="absolute -right-6 -bottom-9 size-40 text-[#B5B5B5]/40" />{" "}
    </Card>
  );
};
